/**
 * Filtro "Feature" por variante — client-side.
 *
 * Só é carregado nas coleções com o metafield `custom.feature_filter_mode` ligado
 * (ver sections/main-collection*.liquid). O grupo de checkboxes vem de
 * snippets/facet-feature-variant.liquid e os cards de snippets/variant-item.liquid,
 * que expõe `data-feature="|valor|valor|"`.
 *
 * Por que client-side: o Liquid não lê query params, então não dá para reconstruir a
 * seleção no servidor. O estado vive na URL (?vfeature=a,b) e é reaplicado aqui.
 *
 * Convivência com o Search & Discovery: os inputs `vfeature` ficam dentro do
 * #facet-filters-form, então o FormData do tema já os carrega para a URL quando um
 * filtro nativo muda. Como o ProductFacet troca o innerHTML de #facet-main e
 * #facet-filters no re-render AJAX, tudo aqui é delegado no document e reaplicado
 * por MutationObserver.
 */
(function () {
  'use strict';

  var PARAM = 'vfeature';
  var observer = null;
  var isApplying = false;

  function getSelected() {
    var raw = new URLSearchParams(window.location.search).getAll(PARAM);
    var values = [];

    // O param pode vir repetido (FormData) ou separado por vírgula (nosso replaceState).
    raw.forEach(function (chunk) {
      chunk.split(',').forEach(function (value) {
        var clean = value.trim().toLowerCase();
        if (clean && values.indexOf(clean) === -1) values.push(clean);
      });
    });

    return values;
  }

  function setSelected(values) {
    var url = new URL(window.location.href);
    url.searchParams.delete(PARAM);
    if (values.length > 0) url.searchParams.set(PARAM, values.join(','));
    window.history.replaceState({}, '', url.toString());
  }

  function getCards() {
    var main = document.getElementById('facet-main');
    return main ? Array.prototype.slice.call(main.querySelectorAll('[data-feature]')) : [];
  }

  function matches(card, selected) {
    var haystack = (card.getAttribute('data-feature') || '').toLowerCase();
    // OR dentro do grupo, igual ao comportamento nativo do Search & Discovery.
    return selected.some(function (value) {
      return haystack.indexOf('|' + value + '|') !== -1;
    });
  }

  function toggleEmptyState(show, container) {
    var existing = container.parentNode.querySelector('[data-variant-feature-empty]');

    if (!show) {
      if (existing) existing.remove();
      return;
    }
    if (existing) return;

    var node = document.createElement('div');
    node.className = 'empty-state';
    node.setAttribute('data-variant-feature-empty', '');
    node.innerHTML =
      '<p>No products match the selected filters.</p>' +
      '<div class="button-wrapper"><button type="button" class="button button--primary" data-variant-feature-clear>Clear filters</button></div>';
    container.parentNode.insertBefore(node, container.nextSibling);
  }

  function apply() {
    var cards = getCards();
    if (cards.length === 0) return;

    var selected = getSelected();
    var visible = 0;

    cards.forEach(function (card) {
      var show = selected.length === 0 || matches(card, selected);
      card.style.display = show ? '' : 'none';
      if (show) visible++;
    });

    // Contagem por valor ignora a própria seleção, como os contadores nativos.
    document.querySelectorAll('[data-variant-feature-count]').forEach(function (node) {
      var value = node.getAttribute('data-variant-feature-count');
      var count = cards.filter(function (card) {
        return matches(card, [value]);
      }).length;
      node.textContent = '(' + count + ')';
    });

    var selectedLabel = document.querySelector('[data-variant-feature-selected]');
    if (selectedLabel) selectedLabel.textContent = selected.join(', ');

    var container = cards[0].closest('.product-list__inner');
    if (container) toggleEmptyState(visible === 0, container);
  }

  /** Remarca os checkboxes a partir da URL — necessário após cada re-render do tema. */
  function restore() {
    var selected = getSelected();
    var inputs = document.querySelectorAll('[name="' + PARAM + '"]');
    if (inputs.length === 0) return;

    inputs.forEach(function (input) {
      input.checked = selected.indexOf(input.value.toLowerCase()) !== -1;
    });

    // Abre o grupo quando há seleção, para a escolha não ficar escondida no collapsible.
    if (selected.length > 0) {
      var group = document.querySelector('[data-variant-feature-filter]');
      if (group) {
        var content = group.querySelector('collapsible-content');
        var toggle = group.querySelector('.collapsible-toggle');
        if (content) content.setAttribute('open', '');
        if (toggle) toggle.setAttribute('aria-expanded', 'true');
      }
    }
  }

  function refresh() {
    if (isApplying) return;
    isApplying = true;
    if (observer) observer.disconnect();

    restore();
    apply();

    if (observer) observe();
    isApplying = false;
  }

  function observe() {
    var host = document.querySelector('product-facet');
    if (host && observer) observer.observe(host, { childList: true, subtree: true });
  }

  function onChange(event) {
    var input = event.target;
    if (!input.name || input.name !== PARAM) return;

    var selected = getSelected();
    var value = input.value.toLowerCase();
    var index = selected.indexOf(value);

    if (input.checked && index === -1) selected.push(value);
    if (!input.checked && index !== -1) selected.splice(index, 1);

    setSelected(selected);
    apply();
  }

  function onClick(event) {
    var trigger = event.target.closest('[data-action="clear-filters"], [data-variant-feature-clear]');
    if (!trigger) return;

    // O "clear" nativo é um link que dispara o re-render; só precisamos limpar o nosso param.
    setSelected([]);

    if (trigger.hasAttribute('data-variant-feature-clear')) {
      event.preventDefault();
      refresh();
    }
  }

  function init() {
    document.addEventListener('change', onChange);
    document.addEventListener('click', onClick);

    observer = new MutationObserver(function () {
      window.requestAnimationFrame(refresh);
    });

    observe();
    refresh();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
